import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, WishlistProductType } from './types'

export const WishlistSlice = createSlice({
  name: 'wishlistSlice',
  initialState,
  reducers: {
    updateWishList(state, action: PayloadAction<WishlistProductType[]>) {
      return (state = action.payload)
    },
    addOrRemoveFromWishlist(state, action: PayloadAction<WishlistProductType>) {
      const doesExist = state.find(
        (el) =>
          el.id === action.payload.id &&
          el.productTemplateId === action.payload.productTemplateId
      )
      if (doesExist) {
        return (state = state.filter(
          (el) =>
            el.id !== action.payload.id &&
            el.productTemplateId !== action.payload.productTemplateId
        ))
      }
      return (state = [...state, action.payload])
    },
    clearWishList(state) {
      console.log(' wishlist is cleared from reducer')
      return initialState
    },
  },
})

export default WishlistSlice.reducer
